module.exports = __webpack_public_path__ + "static/media/map-values-icon.b2bb2eab.svg";